/**
 * Product FAQ modal — open/close only.
 * Markup and FAQ content are rendered in Liquid.
 */
class ProductFaqModal extends HTMLElement {
  connectedCallback() {
    this._onKeydown = this._onKeydown.bind(this);
    this._onTriggerClick = this._onTriggerClick.bind(this);

    this.querySelectorAll('[data-product-faq-close]').forEach((el) => {
      el.addEventListener('click', () => this.close());
    });

    document.addEventListener('click', this._onTriggerClick);
    document.addEventListener('keydown', this._onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onTriggerClick);
    document.removeEventListener('keydown', this._onKeydown);
  }

  _onTriggerClick(event) {
    const trigger = event.target.closest('[aria-controls="' + this.id + '"]');
    if (!trigger) return;
    event.preventDefault();
    this.open();
  }

  _onKeydown(event) {
    if (event.key === 'Escape' && !this.hasAttribute('hidden')) {
      this.close();
    }
  }

  open() {
    this.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    this.querySelector('.product-faq-modal__close')?.focus();
  }

  close() {
    this.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }
}

if (!window.customElements.get('product-faq-modal')) {
  window.customElements.define('product-faq-modal', ProductFaqModal);
}
